import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCompare, removeFromCompare, clearCompare } from '../utils/compare';
import { XMarkIcon, TrashIcon } from '@heroicons/react/24/outline';

const ComparePopover = () => {
 const [items, setItems] = useState([]);
 const navigate = useNavigate();

 useEffect(() => {
 // Initial load
 const initial = getCompare();
 setItems(initial);

 // Listen to custom compare event
 const handleCompareUpdate = (e) => {
 setItems(e.detail || []);
 };

 // Also listen to storage events for cross-tab sync
 const handleStorageChange = (e) => {
 if (e.key === 'dakhla_compare_items_v1') {
 const updated = getCompare();
 setItems(updated);
 }
 };

 window.addEventListener('compareUpdated', handleCompareUpdate);
 window.addEventListener('storage', handleStorageChange);

 return () => {
 window.removeEventListener('compareUpdated', handleCompareUpdate);
 window.removeEventListener('storage', handleStorageChange);
 };
 }, []);

 if (!items || items.length === 0) {
 return null;
 }

 const handleCompare = () => {
 const ids = items.map(i => `${i.id}:${i.type || 'partner'}`).join(',');
 navigate(`/compare?ids=${ids}`);
 };

 return (
 <div className="fixed left-0 right-0 bottom-6 z-50 flex justify-center pointer-events-none px-4">
 <div className="pointer-events-auto bg-white border border-slate-300 shadow-xl rounded-2xl p-4 max-w-4xl w-full flex flex-col md:flex-row items-center gap-4 transition-all duration-300 transform translate-y-0 animate-fade-in-up">
 
 {/* Compare Items */}
 <div className="flex-1 flex items-center gap-3 overflow-x-auto w-full scrollbar-hide py-1">
 {items.map(it => (
 <div 
 key={it.uniqueId || `${it.type || 'partner'}:${it.id}`} 
 className="flex items-center gap-2.5 bg-slate-100 hover:bg-slate-100 border border-slate-300 rounded-xl px-3 py-1.5 flex-shrink-0 transition-all duration-200"
 >
 {(it.university?.profile_picture || it.university?.logo) && (
 <img 
 src={it.university?.profile_picture || it.university?.logo} 
 alt={it.program_name} 
 className="w-7 h-7 object-contain rounded-lg bg-white p-0.5 border border-slate-200 flex-shrink-0" 
 />
 )}
 <div className="text-xs min-w-max">
 <div className="font-extrabold text-slate-900 leading-tight truncate max-w-[130px]">{it.program_name}</div>
 <div className="text-[10px] text-slate-500 font-bold leading-none mt-0.5 truncate max-w-[130px]">{it.university?.name}</div>
 </div>
 <button
 onClick={() => {
 removeFromCompare(it.id, it.type);
 setItems(getCompare());
 }}
 className="ml-1.5 p-1 rounded-full text-slate-400 hover:text-red-500 hover:bg-red-50 transition-colors"
 title="Remove program"
 >
 <XMarkIcon className="h-3.5 w-3.5" />
 </button>
 </div>
 ))}
 </div>

 {/* Action Buttons */}
 <div className="flex items-center gap-3 w-full md:w-auto shrink-0 justify-between md:justify-end border-t md:border-t-0 pt-3 md:pt-0 border-slate-200 md:border-l md:pl-4">
 <button
 onClick={() => {
 clearCompare();
 setItems([]);
 }}
 className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-red-600 transition-colors font-bold px-3 py-2 rounded-lg hover:bg-red-50/50"
 >
 <TrashIcon className="h-4 w-4" />
 Clear
 </button>
 <button
 onClick={handleCompare}
 className="flex-1 md:flex-none md:w-auto bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white px-5 py-2.5 rounded-xl text-sm font-extrabold shadow-lg shadow-primary-500/20 hover:shadow-primary-500/35 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 shrink-0"
 >
 Compare ({items.length})
 </button>
 </div>
 </div>
 </div>
 );
};

export default ComparePopover;
